import { action, makeObservable, observable } from 'mobx';

import DisturbanceApi from '@api/DisturbanceApi';
import RootStore from '@stores/RootStore';
import SsoStore from '@stores/SsoStore';
import { FilterState } from '@config/DisturbanceFilter';
import { DisturbanceTabs } from '@config/DisturbanceConfig';
import { getAuthType, removeNullFilterValues } from '@util/ApiUtil';

export default class TabStore {
  @observable accessor tabs: DisturbanceTabs;
  @observable accessor currentTab: string = undefined;

  private readonly ssoStore: SsoStore;

  public constructor(rootStore: RootStore) {
    makeObservable(this);
    this.ssoStore = rootStore.ssoStore;
  }

  @action
  public async fetchTabs(filter: FilterState): Promise<void> {
    removeNullFilterValues(filter);
    try {
      this.tabs = await DisturbanceApi.getTabs(this.currentTab, filter, getAuthType(this.ssoStore.loggedIn, this.ssoStore.isDealer));
    } catch (err) {
      console.error(err);
      this.tabs.changes = null;
      this.tabs.incidents = null;
      this.tabs.problems = null;
    }
  }

  @action
  public setTab = async (tab: string, filter: FilterState): Promise<void> => {
    this.currentTab = tab;
    await this.fetchTabs(filter);
  };
}
